import { z } from "zod";

/** Player link and invite tokens are 32 random bytes, unpadded base64url (43 chars). */
export const TOKEN_PATTERN = /^[A-Za-z0-9_-]{43}$/;
export const PLAYER_TOKEN_PATTERN = TOKEN_PATTERN;

export const tokenSchema = z.string().regex(TOKEN_PATTERN);

const emailSchema = z.string().trim().toLowerCase().pipe(z.email().max(254));

export const inviteRoleSchema = z.enum(["owner", "member"]);

export const devLoginSchema = z.object({
  email: emailSchema,
  invite: tokenSchema.optional(),
});

export const adminInviteSchema = z.object({
  email: emailSchema,
  workspaceName: z.string().trim().min(1).max(80).optional(),
});

export const workspaceInviteSchema = z.object({
  email: emailSchema,
  role: inviteRoleSchema,
});

export const googleStartQuerySchema = z.object({
  invite: tokenSchema.optional(),
});

export type DevLoginInput = z.infer<typeof devLoginSchema>;
export type AdminInviteInput = z.infer<typeof adminInviteSchema>;
export type WorkspaceInviteInput = z.infer<typeof workspaceInviteSchema>;
export type InviteRoleInput = z.infer<typeof inviteRoleSchema>;
